import { booleanAttribute, Component, inject, input, InputSignal } from '@angular/core';
import { MuiList } from '../mui-list.component';


// noinspection HtmlUnknownAttribute
@Component({
  selector: 'mui-list-item',
  template: `
    <div class="mui-list-item__icon">
      <ng-content select="mui-list-item-icon"></ng-content>
    </div>
    <div class="mui-list-item__text">
      <ng-content></ng-content>
    </div>
    <div class="mui-list-item__actions">
      <ng-content select="mui-list-item-action"></ng-content>
    </div>
  `,
  styleUrl: './mui-list-item.component.scss',
  host: {
    /* eslint-disable @typescript-eslint/naming-convention */
    '[attr.id]': 'id()',
    '[attr.role]': 'button() ? "button" : "listitem"',
    '[attr.disabled]': 'button() && disabled() ? "true" : null',
    '[attr.aria-disabled]': 'button() && disabled() ? "true" : null',
    '[attr.aria-labelledby]': 'id() + "_label"',
    '[class.dense]': 'parentList.dense()',
    '[class.button]': 'button()',
    '[class.disabled]': 'disabled()',
    '[class.mui-list-item]': 'true'
    /* eslint-enable @typescript-eslint/naming-convention */
  }
})
export class MuiListItem {
  static uid = 0;

  readonly button = input(false, { transform: booleanAttribute });
  readonly disabled = input(false, { transform: booleanAttribute });
  readonly id: InputSignal<string>;

  protected readonly parentList = inject(MuiList);

  constructor() {
    this.id = input<string>(this.parentList.id() + '-' + MuiListItem.uid++);
  }
}
